import React from 'react';
import { Button } from 'react-bootstrap';
import SchoolYearPicker from './SchoolYearPicker';
import CompactListTable from './CompactListTable';

/**
 * Page frame for a CRUD list screen: the Add/Show toggle button, an optional
 * school-year picker, an optional filter bar, and either the edit form or the
 * striped single-column table of rows. Purely presentational — all data,
 * fetching, and handlers stay in the feature file. Modals should be rendered as
 * siblings of this component, not passed in.
 *
 * Props:
 *   addLabel, listLabel  strings for the toggle button (add vs. list mode)
 *   showForm, onToggleForm
 *   tableHeading         label for the single <th>
 *   schoolYear?          { list, selected, onChange } -> renders SchoolYearPicker
 *   filters?             node rendered above the table (use <FilterBar>)
 *   form?                node rendered in place of the table when showForm
 *   emptyState?          full <tr> shown when there are no children rows
 *   scrollable?          wrap the table in .scrollable-table (default true)
 *   children             the <tbody> rows (usually <ExpandableRow>s)
 */
const CrudListShell = ({
  addLabel,
  listLabel,
  showForm,
  onToggleForm,
  tableHeading,
  schoolYear,
  filters,
  form,
  emptyState,
  scrollable = true,
  children,
}) => {
  return (
    <>
      {onToggleForm ? (
        <Button onClick={onToggleForm} className="m-1">
          {showForm ? listLabel : addLabel}
        </Button>
      ) : null}

      {schoolYear ? (
        <SchoolYearPicker
          list={schoolYear.list}
          selected={schoolYear.selected}
          onChange={schoolYear.onChange}
        />
      ) : null}

      {showForm ? (
        form
      ) : (
        <>
          {filters}
          <CompactListTable
            tableHeading={tableHeading}
            emptyState={emptyState}
            scrollable={scrollable}
          >
            {children}
          </CompactListTable>
        </>
      )}
    </>
  );
};

export default CrudListShell;
